import React, { FC } from 'react'

import Box from '@mui/material/Box'
import SlideMenu from '@app/pages/Dashboard/SideBar/SlideMenu/SlideMenu'

import { SidebarBox } from './styled'
import StaticMenu from './StaticMenu/StaticMenu'

const SideBar: FC = function () {
	return (
		<SidebarBox>
			<StaticMenu />

			<Box position={'relative'} display={'flex'}>
				<SlideMenu />
			</Box>
		</SidebarBox>
	)
}

export default SideBar
